export default __webpack_public_path__ + "static/media/100_39413.8a770f0d.jpg";